export function reportRuntimeError(observabilityFns, error, messagePrefix) {
    var _observabilityFns_errors;
    if (!observabilityFns) {
        return;
    }
    const errorStack = error instanceof Error ? error.stack : undefined;
    const originalErrorMessage = error instanceof Error ? error.message : String(error);
    const fullMessage = messagePrefix ? `${messagePrefix}: ${originalErrorMessage}` : originalErrorMessage;
    (_observabilityFns_errors = observabilityFns.errors) === null || _observabilityFns_errors === void 0 ? void 0 : _observabilityFns_errors.error(fullMessage, {
        project: 'sail_core',
        extras: {
            error,
            errorStack
        }
    });
}

//# sourceMappingURL=internalReporting.js.map